import React, { useEffect } from 'react';
import styles from './ErrorPage.module.scss';
import Logo from '../../assets/Logotype-Colored.svg';
import { Icon } from '../../../engage/components/Icon';
import { CustomButton } from '../../../engage/components/Button/Button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function ErrorPage(props) {
  const { t } = useTranslation();
  let history = useHistory();

  useEffect(() => {
    history.block(() => true);
  }, []);

  if (props.errorTitle) {
    return (
      <div>
        <div className={styles.logoContainer}>
          <div className={styles.logo} onClick={() => history.push('/eg/dashboard')}>
            <img src={Logo} alt="VormatsLogo" />
          </div>
        </div>
        <div className={styles.content}>
          <Icon src="NotFound" />
          <span className={styles.errorMessage}>{t('general.error_page.title')}</span>
          <span className={styles.errorCode}>{t('general.error_page.bottom_text')}</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.logoContainer}>
        <div className={styles.logo} onClick={() => history.push('/eg/dashboard')}>
          <img src={Logo} alt="VormatsLogo" />
        </div>
      </div>
      <div className={styles.content}>
        <Icon src="NotFound" />
        <span className={styles.errorMessage}>{t('general.error_404_page.title')}</span>
        <span className={styles.errorCode}>{t('general.error_404_page.bottom_text')}</span>
        <CustomButton label="Back to My library" variant="primary" onClick={() => history.push('/eg/dashboard')} />
      </div>
    </div>
  );
}

export default ErrorPage;
